import { useQuery, UseQueryResult } from 'react-query';
import { PackageRevenueCategoryRetrieve, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUsePackageCategoriesProps {
  _package: string;
}

function usePackageRevenueCategories({
  _package,
}: IUsePackageCategoriesProps): UseQueryResult<{ data: Array<PackageRevenueCategoryRetrieve> }> {
  const params: UrlParams = {};

  if (_package) {
    params.package = _package;
  }

  return useQuery(
    ['packageRevenueCategories', _package],
    () => client.get(`package-revenue-categories/list-package-categories/?${encodeUrlParams(params)}`),
    {
      enabled: !!_package,
    },
  );
}

export default usePackageRevenueCategories;
